export default {
  isDonateVoucherModalOpen: false,
}
